module.exports = __webpack_public_path__ + "be8033a7947e2f4f0872a6019ff9375c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/newMessage.png
// module id = OP68
// module chunks = 27